// extracted by mini-css-extract-plugin
var _1 = "nibRt7hMnu";
var _2 = "AesJV3kRqm";
var _3 = "cpb6XqHcj3";
var _4 = "fLWaMb6AvN";
export { _1 as "anonymousName", _2 as "avatar", _3 as "name", _4 as "userName" }
